var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'nuxt-class-component';
import { Watch } from 'vue-property-decorator';
import MapMixin from 'mixins/map';
import Rules from 'mixins/rules';
import { OrderAction, OrderGetter } from 'store/index';
import SearchAddress, { TYPES_ADDRESS } from 'components/forms/SearchAddress.vue';
import RadioGroup from 'components/common/RadioGroup.vue';
import RadioButton from 'components/common/RadioButton.vue';
import CONSTANTS from 'services/CONSTANTS';
var MapRoute = (function (_super) {
    __extends(MapRoute, _super);
    function MapRoute() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.btnLoading = false;
        _this.isNormalCar = null;
        _this.TYPES_ADDRESS = TYPES_ADDRESS;
        return _this;
    }
    Object.defineProperty(MapRoute.prototype, "originAddress", {
        get: function () {
            var order = this.orderInfo;
            return (order.origin_address + ", " + order.origin_postal_code + " " + order.origin_city)
                .replace(CONSTANTS.DEFAULT_POSTAL_CODE, '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapRoute.prototype, "destinationAddress", {
        get: function () {
            var order = this.orderInfo;
            return (order.destination_address + ", " + order.destination_postal_code + " " + order.destination_city)
                .replace(CONSTANTS.DEFAULT_POSTAL_CODE, '');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapRoute.prototype, "maximumPackageText", {
        get: function () {
            return this.$t('index.maximum_package') + "\n       <a href=\"/contacts\" class=\"link\">" + this.$t('index.take_contact') + "</a>";
        },
        enumerable: true,
        configurable: true
    });
    MapRoute.prototype.requiredNormalCar = function (v) {
        return (v !== undefined && v !== null) || this.$t('form.rules.required');
    };
    MapRoute.prototype.reset = function () {
        this.resetInfo();
        this.resetRoute();
    };
    MapRoute.prototype.getOrderInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var that;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.$refs.mapForm.validate()) return [3, 3];
                        this.btnLoading = true;
                        that = this;
                        if (!(that.start && that.start.position.street_number && that.finish && that.finish.position.street_number)) return [3, 2];
                        return [4, that.getRoute()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (this.orderInfo) {
                            this.setShowOrderPrice(true);
                        }
                        else {
                            this.$toast.error(this.$t('messages.info.empty_point'));
                        }
                        this.btnLoading = false;
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    MapRoute.prototype.onMap = function (val) {
        if (val && this.orderInfo) {
            this.isNormalCar = this.orderInfo.is_normal_car;
            this.setStartPoint(this.orderInfo.origin_city, this.orderInfo.origin_address, this.orderInfo.origin_postal_code, this.orderInfo.origin_lat, this.orderInfo.origin_lng);
            this.setFinishPoint(this.orderInfo.destination_city, this.orderInfo.destination_address, this.orderInfo.destination_postal_code, this.orderInfo.destination_lat, this.orderInfo.destination_lng);
            this.getRoute();
        }
    };
    __decorate([
        OrderGetter('ORDER')
    ], MapRoute.prototype, "orderInfo", void 0);
    __decorate([
        OrderGetter('SHOW_ORDER_PRICE')
    ], MapRoute.prototype, "showOrderPrice", void 0);
    __decorate([
        OrderAction('RESET_ORDER')
    ], MapRoute.prototype, "resetInfo", void 0);
    __decorate([
        OrderAction('SHOW_ORDER_PRICE')
    ], MapRoute.prototype, "setShowOrderPrice", void 0);
    __decorate([
        Watch('startRouteService')
    ], MapRoute.prototype, "onMap", null);
    MapRoute = __decorate([
        Component({
            mixins: [MapMixin, Rules],
            components: {
                'search-address': SearchAddress,
                RadioGroup: RadioGroup,
                RadioButton: RadioButton
            }
        })
    ], MapRoute);
    return MapRoute;
}(Vue));
export default MapRoute;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/public/MapRoute.vue
// module id = ./node_modules/ts-loader/index.js!./node_modules/tslint-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/public/MapRoute.vue
// module chunks = 5